const catalog = {
    title: '[EN] Tryb katalogu',
    action: '[EN] ZAPISZ ZMIANY',
};

export default catalog;